export const test_utils_page = {
  title: "Test Utils",
  enterTestMode: "Enter Test Mode",
};
